import {observer} from 'mobx-react-lite'
import {Box, Button} from '@mui/material'
import {makeOcStyles, getScrollStyle} from '@oc/styles'
import {IconByKey, iconList} from '@oc/icons'
import React from 'react'

interface EmptyComponentAction {
    infoText?: string
    buttonText: string
    action: () => void
    icon: JSX.Element
}

interface EmptyComponentProps {
    header: string
    subheader?: JSX.Element
    actions?: Array<EmptyComponentAction>
}

interface EmptyComponentFullProps {
    element?: JSX.Element
    iconKey?: string
    iconSize?: '16px' | '24px' | '32px' | '40px' | '240px' | undefined
    subheader?: JSX.Element
}

interface IconKeyProps extends Omit<EmptyComponentFullProps, 'element'> {
    element?: undefined
}
interface IconProps extends Omit<EmptyComponentFullProps, 'iconKey' | 'iconSize'> {
    iconSize?: undefined
    iconKey?: undefined
}
type EmptyComponentWithIconProps = IconKeyProps | IconProps

const useEmptyComponentStyles = makeOcStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        overflow: 'auto',
        ...getScrollStyle(undefined, theme.palette.background.paper)
    },
    header: {
        border: '1px solid black',
        display: 'inline-block',
        paddingTop: theme.spacing(1),
        borderRadius: theme.spacing(4),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        backgroundColor: 'rgb(200, 222, 233)'
    },
    subheader: {
        padding: theme.spacing(1),
        display: 'inline-block'
    },
    actions: {
        padding: theme.spacing(1),
        textAlign: 'center'
    }
}))

function _EmptyComponent(props: EmptyComponentProps) {
    const {classes} = useEmptyComponentStyles()
    const header = props.header ? props.header : 'No module available'

    return (
        <Box className={classes.root}>
            <Box className={classes.header}>{header}</Box>
            {props.subheader && <Box className={classes.subheader}>{props.subheader}</Box>}
            <Box>
                {props.actions &&
                    props.actions?.map(value => {
                        return (
                            <Box className={classes.actions}>
                                {value.infoText && <Box>{value.infoText}</Box>}
                                <Button variant="text" onClick={value.action} startIcon={value.icon}>
                                    {value.buttonText}
                                </Button>
                            </Box>
                        )
                    })}
            </Box>
        </Box>
    )
}

export const EmptyComponent = observer(_EmptyComponent)

function _EmptyComponentWithIcon(props: EmptyComponentWithIconProps) {
    const {classes} = useEmptyComponentStyles()

    let iconKey = 'equipment'
    if (props.iconKey && iconList.some(i => i.s2aName === props.iconKey)) {
        iconKey = props.iconKey
    }

    return (
        <Box className={classes.root}>
            {props.element ? (
                props.element
            ) : (
                <IconByKey size={props.iconSize ? props.iconSize : '24px'} iconKey={iconKey} color="disabled" />
            )}
            {props.subheader && <Box className={classes.subheader}>{props.subheader}</Box>}
        </Box>
    )
}

export const EmptyComponentWithIcon = observer(_EmptyComponentWithIcon)
